
import { combineReducers } from "redux";
import general from "./GeneralReducer";

export default combineReducers({ general });
